import { Store } from 'laco';
import { Subscribe } from 'laco-react';
import { getData } from 'Libs/http';
import schema from './schema';

const ApiStore = new Store(schema);

// Setup Middleware
import addBrandInfo from './middleware/addBrandInfo';
import addDoctorUrls from './middleware/addDoctorUrls';
import addSocials from './middleware/addSocials';
import changePlanMedical from './middleware/changePlanMedical';
import convertTypes from './middleware/convertTypes';
import medicalTable from './middleware/medicalTable';
import medicalTab from './middleware/medicalTab';
import mobileAppInfo from './middleware/mobileAppInfo';
import setTitle from './middleware/setTitle';
import guidance from './middleware/guidance';
import wellness from './middleware/wellness';
import addCITitle from './middleware/addCITitle';

// NOTE: The functions are executed in order
const middleware = [
  convertTypes,
  setTitle,
  medicalTable,
  addSocials,
  addDoctorUrls,
  addBrandInfo,
  addCITitle,
  changePlanMedical,
  mobileAppInfo,
  guidance,
  wellness,

   
];

const updateApiStore = async function() {
  const state = await getData();
  middleware.forEach(fn => fn(state));
  ApiStore.set(() => state);
  return state;
  
};

export { Subscribe, updateApiStore, ApiStore };
